import { observer } from 'mobx-react-lite'
import React from 'react'
import { Text } from 'react-native'
import { useInvoiceDetailsContext } from '../../../TabInvoice/InvoiceDetailsContext'
import { Trans, useTranslation } from 'react-i18next'
import { useResponsive } from '@linqpal/components/src/hooks'
import { paths } from '../../../../links'
import { PromptSuccessIcon } from '../../../../../assets/icons'
import { SuccessFailurePrompt } from '../../../../../ui/molecules/SuccessFailurePrompt'

interface AddProjectSuccessModalProps {
  builderCreatedInvoice?: boolean
  navigation: any
  companyName: string
}

export const AddProjectSuccessModal: React.FC<AddProjectSuccessModalProps> =
  observer(({ builderCreatedInvoice, navigation, companyName }) => {
    const {
      addProjectSuccessModalVisibility: visible,
      setAddProjectSuccessModalVisibility: setVisible,
      selectedProject,
    } = useInvoiceDetailsContext()
    const { t } = useTranslation('global')
    const { md } = useResponsive()
    return (
      <SuccessFailurePrompt
        visible={visible}
        onDismiss={() => {
          setVisible(false)
          navigation.navigate(paths.Console.Payables.home)
        }}
        title={t('AddedToProjectAlert.title')}
        icon={<PromptSuccessIcon style={{ width: 108, height: 108 }} />}
        message={
          builderCreatedInvoice ? (
            <Trans
              t={t}
              i18nKey="AddedToProjectAlert.for-uploaded-invoice"
              values={{ projectName: selectedProject.name }}
              components={{
                styled: <Text style={{ fontWeight: '600' }} />,
                simple: <Text />,
              }}
            />
          ) : (
            <Trans
              t={t}
              i18nKey="AddedToProjectAlert.for-received-invoice"
              values={{
                companyName,
                projectName: selectedProject.name,
              }}
              components={{
                styled: <Text style={{ fontWeight: '600' }} />,
                simple: <Text />,
              }}
            />
          )
        }
        buttonData={{
          title: 'View Project',
          contentStyle: { width: '100%' },
          style: { width: '90%' },
          onPress: () => {
            setVisible(false)
            if (md) {
              // Currently projects is inside more for small screens
              navigation.navigate(paths.Console.Projects._self, {
                screen: paths.Console.Projects.Details,
                params: { project: selectedProject },
              })
            } else {
              navigation.navigate(paths.Console.More._self, {
                screen: paths.Console.Projects._self,
                params: {
                  screen: paths.Console.Projects.Details,
                  params: { project: selectedProject },
                },
              })
            }
          },
        }}
      />
    )
  })
